import { LABEL_FONT, TEXT_FONT_SIZE } from '../../constants';
export const getFontStyles = ({ fontSize }) => ({
    font: LABEL_FONT,
    fontSize: `${fontSize || TEXT_FONT_SIZE}px`,
});
export const textContainsMultipleLines = (text) => Boolean((text ?? '').match(/[\n]/));
export const countTextRows = (text) => ((text ?? '').match(/\n/g)?.length ?? 0) + 1;
//# sourceMappingURL=utils.js.map